import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import SideBar from "../../Sections/SideBar";
import Navbar from "../../Sections/NavBar";
import MobileNav from "../../Sections/MobileNav";
import { useSelector } from "react-redux";

function BankTransfer() {
  const user = useSelector((state) => state.user.user);
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");


  useEffect(() => {
    if (user.first_name && user.last_name) {
      setAccountName(`${user.first_name} ${user.last_name}`);
    } 
    if (user.wallets && user.wallets.length) {
      setAccountNumber(user.wallets[0].account_no);
    }
    setBankName("KEGOW(CHAMSMOBILE)");
  }, [user]);

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <div className="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">
              <h2 className="mb-5 text-primary fw-bold">Bank-to-Wallet Transfer</h2>
              <div className="card shadow p-4">
                <div className="card-body">
                  <h3 className="card-title text-muted">
                    Fund Your Wallet via Your Bank or Debit Card 
                  </h3>
                  <form>
                    <div className="form-group mb-5">
                      <label className="form-label" htmlFor="transferAmount">
                        Bank Name
                      </label>

                      <input
                        id="bankName"
                        name="bankName"
                        type="text"
                        className="form-control"
                        placeholder="Bank Name"
                        value={bankName}
                        title="Bank Name"
                        disabled
                      />
                    </div>
                    <div className="form-group mb-5">
                      <label className="form-label" htmlFor="transferAmount">
                        Account Number
                      </label>
                      <input
                        id="accountNumber"
                        name="accountNumber"
                        value={accountNumber}
                        type="number"
                        className="form-control"
                        placeholder="Account Number"
                        title="Numbers only"
                        maxLength="11"
                        disabled
                      />
                    </div>

                    <div className="form-group mb-5">
                      <label className="form-label" htmlFor="transferAmount">
                        Account Name
                      </label>

                      <input
                        id="accountName"
                        name="accountName"
                        type="text"
                        className="form-control"
                        placeholder="Account Name"
                        value={accountName.toUpperCase()}
                        title="Account Name"
                        disabled
                      />
                    </div>
                    {/* <button
                      type="submit"
                      className="btn w-100 my-3 btn-primary"
                    >
                      Copy to Clipboard
                    </button> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BankTransfer;
